import InGamePlayerList from "./InGamePlayerList";
import ButtonBox from "./ButtonBox";
import "./GamePage.css";
import DiceBox from "./DiceBox";
import ScoreCard from "./ScoreCard";
import { useAppSelector } from "./store";
import { PlayerInfo } from "./common/Info";
import PhaseBox from "./PhaseBox";
import LockModal from "./LockModal";
import OtherScoreCards from "./OtherScoreCards";
import useMediaQuery from "./hooks/useMediaQuery";
import CurrentTurnBanner from "./CurrentTurnBanner";
import DisconnectModal from "./DisconnectModal";
import ScoreDescription from "./ScoreDescription";

function findIndexById(arr: PlayerInfo[], idToFind: string) {
  return arr.findIndex((obj) => obj.id === idToFind);
}

function GamePage() {
  const players = useAppSelector((state) => {
    return state.players;
  });
  const userProfile = useAppSelector((state) => {
    return state.profile;
  });

  const isSmallScreen = useMediaQuery("(max-width: 600px)");

  const userIndex = findIndexById(players, userProfile.id);
  const user = players[userIndex];
  const targetScorecard = user
    ? user.scoreCard
    : {
        red: [],
        yellow: [],
        blue: [],
        green: [],
        penalties: 0,
      };

  const size = isSmallScreen ? "small" : "large";

  return (
    <div className="gamePageContainer">
      <div className="gridContainer height100">
        <InGamePlayerList />
        <ScoreCard
          scoreCard={targetScorecard}
          playable={true}
          size={size}
          playerName="You"
        />
        <DiceBox />
        <div className="gameLog"></div>
        <ButtonBox />
        <PhaseBox />
        <CurrentTurnBanner />
        <LockModal />
        <OtherScoreCards />
      </div>
      <DisconnectModal />
    </div>
  );
}

export default GamePage;
